import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import Loader from "react-js-loader";
import InputField from '../../../../components/InputField';
import axiosInstance from '../../../../services/AxiosInstance';

const Tab1MatchedCandidates = ({ id, vac }) => {

    let cancelToken;

    const [data, setData] = useState([]);
    const [candidates, setCandidates] = useState([]);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    const getData = (page = 1) => {
        setLoader(true);
        axiosInstance(`candidate-profile/?joc-filter-candidates=${id}&page=${page}`)
            .then(res => {
                setData(res.data);
                let candidates = res.data.results;
                setCandidates(
                    candidates.map(candidate => {
                        return {
                            ...candidate,
                            select: false
                        }
                    })
                );
            }).finally(() => setLoader(false));
    }

    const handleSearchChange = async e => {
        // Function to cancel previous request on searching for api optimization
        if (typeof cancelToken != typeof undefined) {
            cancelToken.cancel("Operation canceled due to new request.")
        }
        cancelToken = axios.CancelToken.source()
        try {
            await axiosInstance(
                `candidate-profile/?joc-filter-candidates=${id}&search=${e.target.value}`,
                {
                    method: "GET",
                    cancelToken: cancelToken.token
                }).then(res => {
                    setData(res.data);
                    let candidates = res.data.results;
                    setCandidates(
                        candidates.map(candidate => {
                            return {
                                ...candidate,
                                select: false
                            }
                        })
                    );
                })
        } finally {
            return data
        }
    }

    const handleApprove = () => {
        let profiles = [];
        candidates.filter(can => can.select).forEach(can => {
            profiles.push(can.user.id);
        })
        axiosInstance('can-applyjob/bulk-apply/', { method: "POST", data: { profiles: profiles, job_id: id, vac: +vac } })
            .then(res => {
                if (res.status === 200) {
                    swal("", "Forwarded Successfully", "success", { button: "Ok!", });
                    getData();
                }
            }).catch(err => swal("", err.response.data.detail, "error", { button: "Ok!", }))
    }

    if (loader) return <Loader
        type="spinner-cub"
        bgColor={"#2e55fa"}
        title={"bubble-top"}
        color={'#FFFFFF'}
        size={100}
    />

    return (
        <div className="table-resposive template-table">
            {
                candidates.filter(d => d.select).length > 0 &&
                <button
                    className="site-button btn-sm btn-success"
                    onClick={handleApprove}
                    title="Click here to approve the selected candidates"
                >
                    Approve & Forward
                </button>
            }
            <InputField
                className="small-input w-25 float-right"
                placeholder='Search...'
                onChange={handleSearchChange}
            />
            <table className="table-job-bx cv-manager company-manage-job">
                <thead>
                    <tr>
                        <th className="feature">
                            <input
                                type="checkbox"
                                onChange={(e) => {
                                    let checked = e.target.checked;
                                    setCandidates(candidates.map(d => {
                                        d.select = checked;
                                        return d;
                                    }))
                                }}
                                checked={candidates.length > 0 && candidates.every(d => d.select)}
                            />
                        </th>
                        <th>Name</th>
                        <th>Professional Title</th>
                        <th>Job Titles</th>
                        <th>Gender</th>
                        <th>Categories</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        candidates?.length > 0 ? candidates?.map((res, i) => {
                            return (
                                <tr key={i}>
                                    <td className="feature">
                                        <input
                                            type="checkbox"
                                            checked={candidates[i].select}
                                            onChange={(e) => {
                                                candidates[i].select = e.target.checked;
                                                setCandidates([...candidates])
                                            }}
                                        />
                                    </td>
                                    <td className="job-name">
                                        <Link to={"#"}>{res?.user.first_name} {res?.user.last_name}</Link>
                                        <ul className="job-post-info">
                                            <li><i className="fa fa-map-marker"></i> {res.state.name}, {res.country.name}</li>
                                        </ul>
                                    </td>
                                    <td className="application text-primary">{res.professional_title}</td>
                                    <td className="application text-primary">{res.job_titles?.join(', ')}</td>
                                    <td className="application text-primary">{res?.gender?.name}</td>
                                    <td className="application text-primary">{res?.category?.join(', ')}</td>
                                    <td className="job-links text-center" style={{ display: "table-cell" }} >
                                        <Link to={`/emp-candidate/${res?.user.id}/can-full-profile/`} >
                                            <i className="fa fa-eye"></i>
                                        </Link>
                                    </td>
                                </tr>
                            )
                        })
                            :
                            <tr>
                                <td colSpan="6" className="text-center">No data found</td>
                            </tr>
                    }
                </tbody>
            </table>
        </div>
    );
};

export default Tab1MatchedCandidates;